import React, { useState, useEffect } from 'react'
import FilterDropdown from 'live/components/forms/ui/filter-dropdown'
import promiseAllObjectValues from 'promise-all-object-values'
import Select from 'react-select'
import { getLookup } from '../../api/lookups'
import styled from 'styled-components'
import i18n from 'live/services/i18n'
import './style.scss'

const FilterDropdownLookup = ({ filters, applyCallback }: any) => {
    const [lookups, setLookups] = useState<any>({})
    const [filtersAndSelected, setFiltersAndSelected] = useState<any>({})
    const [filtersAndSelectedOpen, setFiltersAndSelectedOpen] = useState<boolean>(false)
    const [isAppling, setIsAppling] = useState<boolean>(false)

    useEffect(() => {
        init()
    }, [])

    const init = () => {
        const promisesDictionary: any = {}

        if (filters.length > 0) {
            filters.forEach(({ lookup }) => {
                if (lookup) promisesDictionary[lookup] = Promise.resolve(getLookup(lookup))
            })
        }

        promiseAllObjectValues(promisesDictionary).then(response => {
            if (filters.length > 0) {
                const obj = {}
                filters.forEach(({ lookup }) => {
                    if (lookup && response[lookup]) {
                        obj[lookup] = {
                            // key,
                            values: response[lookup].data?.entries.map(({ key, value }) => ({
                                value: key,
                                label: value
                            }))
                        }
                    }
                })

                setLookups(obj)
            }
        })
    }

    const apply = (): void => {
        setIsAppling(true)

        const run = (): void => {
            const aux = {}

            for (const key in filtersAndSelected) {
                if (filtersAndSelected[key].length > 0) aux[key] = filtersAndSelected[key]
            }

            applyCallback({ ...aux })
            setIsAppling(false)
            clearInterval(intervalID)
        }

        const intervalID = setInterval(run, 1000)
    }

    const removeAll = () => {
        setFiltersAndSelected({})
        applyCallback({})
    }

    return (
        <FilterDropdown
            // ref="dropdown"
            hideTitle={true}
            open={filtersAndSelectedOpen}
            onClick={() => {
                setFiltersAndSelectedOpen(!filtersAndSelectedOpen)
            }}
            containerClassName={'override-dropdown'}
            disableTooltip={true}
            btnCls="btn-action btn-blue"
            btnLabel={
                <span>
                    <i className={`${Object.entries(filtersAndSelected).length === 0 ? 'far' : 'fas'} fa-filter`} />
                </span>
            }
        >
            <div>
                <StyleContainer>
                    {filters.map(({ name, key, lookup }) => {
                        return (
                            <ContainerSelect key={key}>
                                <label>{name}</label>

                                <Select
                                    multi
                                    value={filtersAndSelected[lookup]}
                                    onChange={target => {
                                        const obj = { ...filtersAndSelected }
                                        obj[lookup] = target

                                        if (obj[lookup].length === 0) {
                                            delete obj[lookup]
                                        }

                                        setFiltersAndSelected(obj)
                                    }}
                                    name={name}
                                    options={lookups[lookup]?.values}
                                    className="basic-multi-select"
                                />
                            </ContainerSelect>
                        )
                    })}
                </StyleContainer>
                <StyleContainerBtn>
                    <button
                        disabled={isAppling || Object.entries(filtersAndSelected).length === 0}
                        className="btn btn-primary"
                        onClick={apply}
                    >
                        {isAppling ? <i className="fas fa-spinner fa-spin"></i> : <></>}
                        {i18n('Apply')}
                    </button>
                    <StyleBtnRemove className="btn" onClick={removeAll}>
                        {i18n('Remove All')}
                    </StyleBtnRemove>
                </StyleContainerBtn>
            </div>
        </FilterDropdown>
    )
}

export default React.memo(FilterDropdownLookup)

const ContainerSelect = styled.div`
    margin-bottom: 12px;
`
const StyleBtnRemove = styled.button`
    background: none;
    color: ${({ theme }) => theme['blue-500']};
    border: none;
`

const StyleContainer = styled.div`
    /* max-height: 493px; */
    height: auto;
    overflow: auto;
    padding: 16px;

    &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }

    &::-webkit-scrollbar-track {
        border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
        background: #bac0cb;
        border-radius: 10px;
    }
`

const StyleContainerBtn = styled.div`
    padding: 10px 15px;
`
